import React from 'react';
import { CenteredModal } from '@app/core';
import { LoginParticipantContent } from './LoginParticipantContent';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onRequestClose?: () => any;
  onSuccess?: () => any;
  children?: React.ReactNode;
}

export const LoginParticipantModal = ({
  isOpen,
  onRequestClose,
  onSuccess,
  children,
}: Props) => {
  const { t } = useTranslation('common');
  return (
    <CenteredModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={t('login.title', { context: 'modal' })}
    >
      <LoginParticipantContent onSuccess={onSuccess} children={children} />
    </CenteredModal>
  );
};
